// import { useDropzone } from 'react-dropzone';

// import Box from '@mui/material/Box';
// import { alpha } from '@mui/material/styles';

// import { Stack, Typography } from '@mui/material';
// import Iconify from '../iconify';
// import { UploadProps } from './types';

// // ----------------------------------------------------------------------

// export default function UploadBox({
//   placeholder,
//   error,
//   disabled,
//   sx,
//   helperText,
//   ...other
// }: UploadProps) {
//   const { getRootProps, getInputProps, isDragActive, isDragReject } = useDropzone({
//     disabled,
//     ...other,
//   });

//   const hasError = isDragReject || error;

//   return (
//     <Box
//       {...getRootProps()}
//       sx={{
//         m: 0.5,
//         width: 64,
//         height: 64,
//         flexShrink: 0,
//         display: 'flex',
//         borderRadius: 1,
//         cursor: 'pointer',
//         alignItems: 'center',
//         color: 'text.disabled',
//         justifyContent: 'center',
//         bgcolor: (theme) => alpha(theme.palette.grey[500], 0.08),
//         border: (theme) => `dashed 1px ${alpha(theme.palette.grey[500], 0.16)}`,
//         ...(isDragActive && {
//           opacity: 0.72,
//         }),
//         ...(disabled && {
//           opacity: 0.48,
//           pointerEvents: 'none',
//         }),
//         ...(hasError && {
//           color: 'error.main',
//           borderColor: 'error.main',
//           bgcolor: (theme) => alpha(theme.palette.error.main, 0.08),
//         }),
//         '&:hover': {
//           opacity: 0.72,
//         },
//         ...sx,
//       }}
//     >
//       <input {...getInputProps()} />

//       <Stack spacing={0.5} alignItems="center">
//         {placeholder && (
//           <Stack spacing={0.5} alignItems="center">
//             <Iconify icon="eva:cloud-upload-fill" width={40} />
//             <Typography variant="body2">{placeholder}</Typography>
//           </Stack>
//         )}

//         {helperText && (
//           <Typography
//             variant="caption"
//             sx={{
//               mx: 'auto',
//               display: 'block',
//               textAlign: 'center',
//               color: 'text.disabled',
//             }}
//           >
//             {helperText}
//           </Typography>
//         )}
//       </Stack>
//     </Box>
//   );
// }

import { useDropzone } from 'react-dropzone';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { alpha } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import Image from '../image';
import Iconify from '../iconify';
import { UploadProps } from './types';

// ----------------------------------------------------------------------

export default function UploadAvatar({
  error,
  file,
  disabled,
  helperText,
  sx,
  placeholder,
  ...other
}: UploadProps) {
  const { getRootProps, getInputProps, isDragActive, isDragReject } = useDropzone({
    multiple: false,
    disabled,
    accept: {
      'image/*': [],
    },
    ...other,
  });

  const hasFile = !!file;

  const hasError = isDragReject || !!error;

  const imgUrl = typeof file === 'string' ? file : file?.preview;

  const renderPreview = hasFile && (
    <Image
      alt="avatar"
      src={imgUrl}
      sx={{
        width: 1,
        height: 1,
        borderRadius: 1,
      }}
    />
  );

  const renderPlaceholder = (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={1}
      className="upload-placeholder"
      sx={{
        top: 0,
        left: 0,
        width: 1,
        height: 1,
        zIndex: 9,
        borderRadius: 1,
        position: 'absolute',
        color: 'text.disabled',
        bgcolor: (theme) => alpha(theme.palette.grey[500], 0.08),
        transition: (theme) =>
          theme.transitions.create(['opacity'], {
            duration: theme.transitions.duration.shorter,
          }),
        '&:hover': {
          opacity: 0.72,
        },
        ...(hasError && {
          color: 'error.main',
          bgcolor: (theme) => alpha(theme.palette.error.main, 0.08),
        }),
        ...(hasFile && {
          zIndex: 9,
          opacity: 0,
          color: 'common.white',
          bgcolor: (theme) => alpha(theme.palette.grey[900], 0.64),
        }),
      }}
    >
      <Iconify icon="eva:cloud-upload-fill" width={32} />

      <Typography variant="body2">{placeholder}</Typography>
    </Stack>
  );

  const renderContent = (
    <Box
      sx={{
        width: 1,
        height: 1,
        overflow: 'hidden',
        borderRadius: 1,
        position: 'relative',
      }}
    >
      {renderPreview}
      {renderPlaceholder}
    </Box>
  );

  return (
    <Stack spacing={0.5}>
      <Box
        {...getRootProps()}
        sx={{
          p: 1,
          m: 'auto',
          width: 144,
          height: 144,
          cursor: 'pointer',
          overflow: 'hidden',
          borderRadius: 1,
          border: (theme) => `1px dashed ${alpha(theme.palette.grey[500], 0.2)}`,
          ...(isDragActive && {
            opacity: 0.72,
          }),
          ...(disabled && {
            opacity: 0.48,
            pointerEvents: 'none',
          }),
          ...(hasError && {
            borderColor: 'error.main',
          }),
          ...(hasFile && {
            ...(hasError && {
              bgcolor: (theme) => alpha(theme.palette.error.main, 0.08),
            }),
            '&:hover .upload-placeholder': {
              opacity: 1,
            },
          }),
          ...sx,
        }}
      >
        <input {...getInputProps()} />

        {renderContent}
      </Box>

      {helperText && (
        <Typography
          variant="caption"
          sx={{
            display: 'block',

            color: 'text.disabled',
          }}
        >
          {helperText}
        </Typography>
      )}
    </Stack>
  );
}
